import { IPlaceBid } from "../types/types";
import { callApi } from "./api.service";

export const PlaceBid = async (
  getToken: () => Promise<string | null>,
  data:IPlaceBid
) => {
  return await callApi("/api/auctions/place-bid", "POST", true, getToken, data);
};

export const GetTax = async (
  getToken: () => Promise<string | null>,
  data:any
) => {
  return await callApi(`/api/auctions/get-sales-tax?amount=${data.amount}&payment_method_id=${data.paymentMethodId}`, "GET", true, getToken);
};